export default class ColorPreset {
	/** @param {AliasColor[]} aliasColors */
	constructor(aliasColors = []) {
		this._colors = new Map();
		for (const aliasColor of aliasColors) {
			this.add(aliasColor)
		}
	}

	/**
	 * @param {string} alias
	 * @returns {string}
	 */
	getColor(alias) {
		return this._colors.get(alias.toLowerCase());
	}

	/** @param {AliasColor} aliasColor */
	add(aliasColor) {
		this._colors.set(aliasColor.alias.toLowerCase(), aliasColor.color)
	}

	/**
	 * @param {AliasColor} existing
	 * @param {AliasColor} replacement
	 */
	replace(existing, replacement) {
		this.remove(existing);
		this.add(replacement);
	}

	/** @param {AliasColor} aliasColor */
	remove(aliasColor) {
		this._colors.delete(aliasColor.alias.toLowerCase());
	}

	getAliasColorsAsArray() {
		return Array.from(this._colors.entries()).map(entry => new AliasColor(entry[0], entry[1]));
	}
}